// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1133":"datadogRecorder","9050":"datadogProfiler"}[chunkId] || chunkId) + "." + {"1133":"85f37994fb014a52","1380":"1254be5487d56cc1","9050":"2455fe2cf363227c"}[chunkId] + ".js";
};